import { toast } from 'sonner';

import { useAuthTokenContext } from '@/auth/KeycloakProvider';

import { AuthConfig, UseAuthReturn } from '../types';

export const useAuth = (_config: AuthConfig): UseAuthReturn => {
  const authContext = useAuthTokenContext();

  const loading = authContext.tokenStatus === 'loading';

  const login = () => {
    authContext.login('/masterclasses');
    return Promise.resolve();
  };

  const handleSignOut = () => {
    toast.success('Successfully logged out');
    authContext.logout();
  };

  return {
    login,
    loading,
    handleSignOut,
  };
};
